import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  serviceTargets: { data: [], loading: false },
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
